import React from 'react';
import i18n from "i18next";
import ModernPieChart from '../components/charts/ModernPieChart';
import ModernBarChart from '../components/charts/ModernBarChart';

function get_elements(string_array, type) {
    let answer = "";
    string_array = (string_array + '').split(',')
    for (const el in string_array) {
        let name_el = string_array[el]
        if (type !== 'age') {
            name_el = i18n.t(`${type}_${string_array[el]}`)
        }
        answer = answer.concat(',', `${name_el}`)
    }
    return answer.slice(1)
}

function my_stringify(json) {
    let array = "";
    for (const el in json) {
        const name_el = i18n.t(`filter_${el}`)
        array = array.concat('', `${name_el}: `);
        array = array.concat('', `${get_elements(json[el], el)}\n`);
    }
    return array;
}


const make_pie_from_json_dict = function (json, header, name_prefix = "") {
    // Return React component instead of CanvasJS config
    return <ModernPieChart data={json} title={header} namePrefix={name_prefix} />;
}


const make_hist_from_json_dict = function (json, header, name_prefix = "") {
    // Return React component instead of CanvasJS config
    return <ModernBarChart data={json} title={header} namePrefix={name_prefix} />;
}


const jsonToTable = function (jsonData) {
    const columns = Object.keys(jsonData);

    // Extract all the keys from the first column to create column headers
    const allKeys = Object.keys(jsonData[columns[0]]);

    const tableData = allKeys.map((key) => {
        const rowData = columns.map((column) => {
            let value = jsonData[column][key];

            // Check if the value is a link (assuming links start with 'http' or 'https')
            if (/^https?:\/\//.test(value)) {
                return (
                    <td key={column}>
                        <a href={value} target="_blank" rel="noopener noreferrer">{i18n.t("link_word")}</a>
                    </td>
                );
            } else {
                return (
                    <td key={column}>{i18n.t(value)}</td>
                );
            }
        });

        return (
            <tr key={key}>
                {rowData}
            </tr>
        );
    });

    const tableHeaders = columns.map((column) => (
        <th key={column}>{i18n.t(`header_${column}`)}</th>
    ));


    if (tableData.length > 0) {
        return (
            <div className="table-responsive modern-table-container">
                <table className="table table-hover modern-table">
                    <thead>
                    <tr>
                        {tableHeaders}
                    </tr>
                    </thead>
                    <tbody>
                    {tableData}
                    </tbody>
                </table>
            </div>
        );
    }else{
        return (
            <div className="empty-state">
                {i18n.t('not_found')}
            </div>
        );
    }
};


const jsonToList = function (jsonData) {
    if (jsonData.length > 0){
        return (
            <ul className="modern-list">
                {jsonData.map((item, index) => (
                    <li key={index}>
                        <a href={item[0]} target="_blank" rel="noopener noreferrer">
                            {i18n.t(item[1])}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }else{
        return (
            <div className="empty-state">
                {i18n.t('not_found')}
            </div>
        );
    }
}


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    make_hist_from_json_dict,
    make_pie_from_json_dict,
    my_stringify,
    jsonToTable,
    jsonToList,
};
